/**
 * Раздел G, этапы жизни: часть 1 — двор, урок, буллинг, первая любовь,
 * свадьба, ночь, разговор (G1–G7); часть 2 — очередь, чемодан, граница,
 * смена, бюджет, отказ, наследство, память (G8–G15).
 */
import type { MinigameDef } from '../types';
import { bullying } from './bullying';
import { firstLove } from './firstLove';
import { lesson } from './lesson';
import { night } from './night';
import { talk } from './talk';
import { wedding } from './wedding';
import { yard } from './yard';
import { clinic } from './clinic';
import { suitcase } from './suitcase';
import { border } from './border';
import { shift } from './shift';
import { budget } from './budget';
import { refusal } from './refusal';
import { legacy } from './legacy';
import { memory } from './memory';

export const LIFE1_MINIGAMES: MinigameDef[] = [
  yard as MinigameDef,
  lesson as MinigameDef,
  bullying as MinigameDef,
  firstLove as MinigameDef,
  wedding as MinigameDef,
  night as MinigameDef,
  talk as MinigameDef,
];

export const LIFE2_MINIGAMES: MinigameDef[] = [
  clinic as MinigameDef,
  suitcase as MinigameDef,
  border as MinigameDef,
  shift as MinigameDef,
  budget as MinigameDef,
  refusal as MinigameDef,
  legacy as MinigameDef,
  memory as MinigameDef,
];

export { yard, lesson, bullying, firstLove, wedding, night, talk, clinic, suitcase, border, shift, budget, refusal, legacy, memory };
